import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 36, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

const line = { hidden: { y: "110%" }, show: (i) => ({ y: "0%", transition: { duration: 1.1, ease: EASE, delay: i * 0.1 } }) };

// Masked line-by-line heading. `onLoad` animates on mount, otherwise on scroll into view.
export const MaskHeading = ({ as = "h2", lines, className = "", onLoad = false, delay = 0, testId }) => {
  const Tag = motion[as];
  const trigger = onLoad ? { animate: "show" } : { whileInView: "show", viewport: { once: true, amount: 0.1 } };
  return (
    <Tag initial="hidden" {...trigger} className={className} data-testid={testId} transition={{ delayChildren: delay }}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.06em] -mb-[0.06em]">
          <motion.span custom={i + delay * 10} variants={line} className={`block ${l.className || ""}`}>
            {l.text}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};
